// extracted by mini-css-extract-plugin
module.exports =  {"line":"DgRbpLn1E_wQobTgc91p","nameLink":"WLPIUh74w5WkADW_QDNP","avatarImage":"kPP97MexfdYDyg4hgjzy"};